import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects';
import { ACTIVATE_NAVIGATION, NAVIGATION_READY } from './Navigation.actions';
import { putAndWaitHandleAllAPIError } from '../../api/API.sagas';
import {
    API_GET_ACCOUNTS_SUCCESS,
    API_GET_APPLICATION
} from '../../api/lendingAPI/LendingAPI.actions';
import { fetchQueryClient } from '../../iwQueryClient/iwQueryClient.sagas';
import { getAccountsQueryConfig } from '@api/lendingAPI/queryConfigs';

export const navigationSagaWorker = [fork(bootstrapNavigationWorker)];

function* bootstrapNavigationWorker() {
    yield takeLatest(ACTIVATE_NAVIGATION, function* () {
        const stateKey = yield select((state) => state.siteContext.state_key);

        const [accountsResponse, [applicationResponse]] = yield all([
            call(fetchQueryClient(getAccountsQueryConfig(stateKey))),
            putAndWaitHandleAllAPIError([{ type: API_GET_APPLICATION }])
        ]);

        yield put({
            type: API_GET_ACCOUNTS_SUCCESS,
            response: accountsResponse
        });

        yield put({
            type: NAVIGATION_READY,
            accountsResponse: accountsResponse,
            applicationResponse: applicationResponse.response
        });
    });
}
